export const readMore = (): void => {
  const articlePage: HTMLElement | null = document.querySelector(
    '.article-page'
  )
  const challengerButton: HTMLElement | null = document.getElementById(
    'clickForMore'
  )
  const related: HTMLDivElement | null = document.querySelector(
    '.article-related-content'
  )
  const buttonWrapper: HTMLDivElement | null = document.querySelector(
    '.read-more__collapse'
  )

  if (articlePage != null && challengerButton != null) {
    const parent = buttonWrapper?.parentNode
    const index: number = Array.prototype.indexOf.call(
      parent?.children,
      buttonWrapper
    )
    if (parent != null) {
      for (let i = Number(index) + 1; i < parent.childElementCount; i++) {
        const children = parent?.children[i]
        ;(children as HTMLElement).style.display = 'none'
      }
    }

    if (related != null) {
      related.style.display = 'none'
    }

    challengerButton.addEventListener('click', function () {
      challengerButton.style.display = 'none'
      if (buttonWrapper != null) {
        buttonWrapper.style.display = 'none'
        if (parent != null) {
          for (let i = Number(index) + 1; i < parent.childElementCount; i++) {
            const children = parent.children[i]
            ;(children as HTMLElement).style.display = 'block'
          }
        }
        if (related != null) {
          related.style.display = 'block'
        }
      }
    })
  }

  if (articlePage == null && challengerButton != null) {
    challengerButton.remove()
  }
}
